import { Suspense } from 'react';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';

import { ErrorPage } from '~/components/ErrorPage';
import { CatalogAnomalyDashboardPage } from '~/modules/marketing/pages/catalog-anomaly-dashboard/CatalogAnomalyDashboardPage';
import { AnomalyDetectionPage } from '~/modules/marketing/pages/catalog-anomaly-dashboard/pages/anomaly-detection/AnomalyDetectionPage';
import { KeyMomentsPage } from '~/modules/marketing/pages/catalog-anomaly-dashboard/pages/key-moments/KeyMomentsPage';
import { ShortTermForecastingPage } from '~/modules/marketing/pages/catalog-anomaly-dashboard/pages/short-term-forecasting/ShortTermForecastingPage';

import { AutomatedCampaignsPage } from '../pages/automated-campaigns/AutomatedCampaignsPage';
import { AutomatedCreatorCampaignPage } from '../pages/automated-creator-campaign/AutomatedCreatorCampaignPage';
import { DigitalCampaignPerformancePage } from '../pages/digital-campaign-performance/DigitalCampaignPerformancePage';
import { MarketingPage } from '../pages/MarketingPage/MarketingPage';

/**
 * Top-level router combining module-level routers
 */
export function Router() {
  return (
    <Suspense>
      <Routes>
        <Route element={<Outlet />}>
          <Route index element={<MarketingPage />} />
          <Route
            path="campaigns"
            element={<DigitalCampaignPerformancePage />}
          />
          <Route
            path="automated-campaigns"
            element={<AutomatedCampaignsPage />}
          />
          <Route
            path="automated-creator-campaigns"
            element={<AutomatedCreatorCampaignPage />}
          />

          <Route path="catalog" element={<CatalogAnomalyDashboardPage />}>
            <Route
              index
              element={<Navigate to="anomaly-detection" replace />}
            />
            <Route
              path="anomaly-detection"
              element={<AnomalyDetectionPage />}
            />

            <Route path="key-moments" element={<KeyMomentsPage />} />

            <Route
              path="short-term-forecasting"
              element={<ShortTermForecastingPage />}
            />
          </Route>

          <Route path="*" element={<ErrorPage type="notFoundPage" />} />
        </Route>
      </Routes>
    </Suspense>
  );
}

Router.displayName = 'MarketingRouter';
